// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XPBpGlvTbBwqGa {
  display: flex;
}
.oXxHZwqu4prnW5 {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-050, 4px);
}
.n_clBJrfXVky6I {
  display: none;
  min-width: 20px;
}
.oXxHZwqu4prnW5:hover .n_clBJrfXVky6I {
  display: block;
}
`, ""]);
// Exports
export var cardName = `XPBpGlvTbBwqGa`;
export var details = `oXxHZwqu4prnW5`;
export var externalLinkIcon = `n_clBJrfXVky6I`;
export default ___CSS_LOADER_EXPORT___;
